import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const dbconnect = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      hero: {
        ...de_DE_formal.translation.hero,
        ...{
          title: "Willkommen bei der Servicepartner-Suche von {{organization}}",
          subtitle: "",
        },
      },
      welcomeModal: {
        ...de_DE_formal.translation.welcomeModal,
        ...{
          title: "Sie verlassen nun die Seite von DB Connect",
          text: "Bitte beachten Sie, dass Sie sich auf einer Website befinden, für deren Inhalt DB Connect nicht verantwortlich ist und die Datenschutzbestimmungen von DB Connect keine Anwendung finden.",
        },
      },
      layout: {
        navbar: {
          partnerLogo: {
            alt: "DB Connect",
          },
        },
      },
      linkToHome: "https://werkstatt.repareo.de/partner/dbconnect",
      benefits: {
        title: "Ihre Vorteile",
        "bullet-point-1": "Freie Termine direkt online buchen",
        "bullet-point-2":
          "Alle Service-Partner auf einem Blick – bewertet nach den Qualitätsstandards von {{organization}}",
        "bullet-point-3":
          "Exklusive Zusatzservices wie Hol- und Bring und Ersatzfahrzeug hinzufügen",
        feedbackText:
          "Sie haben Anregungen oder etwas funktioniert nicht wie erwartet? Wir würden es gerne erfahren.",
        feedbackTitle: "Feedback",
      },
      contact: {
        partner: {
          description: "Technischer Service {{organization}}",
        },
      },
    },
  },
};
